<template>
  <div>
    <div v-if="ready">
      <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-400 mb-5">
        <h1 class="text-4xl">
          {{album.name}}
        </h1>
      </div>
        <div class="ql-snow" v-if="album.description">
          <div class="ql-editor">
            <div class="mb-4 text-center" v-html="album.description"></div>
          </div>
        </div>
      <div>
        <div class="flex justify-between gallery-info px-2 mb-6">
          <NuxtLink :to="'/photo-gallery'" class="text-darkRed pr-1.5 text-tiny capitalize underline underline-offset-1 hover:text-darkBlu">
            back to photo galleries
          </NuxtLink>
          <div class="flex total-galleries text-tiny">
            <p class="number mr-2">{{images.length}}</p>
            <p class="capitalize">total items</p>
          </div>
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-8 gap-3 mb-12">
          <div v-for="(src, index) in images" :key="index" class="pic" @click="() => showImg(index,src.hash)">

            <template v-if="index<1">
              <nuxt-img
                  preload
                  format="webp"
                  rel="preload"
                  class="mx-auto cursor-pointer"
                  :src="siteURL + '/storage/images/gallery/' + album_path + '/thumbnail_cache/' +src.hash"
                  :alt="src.hash"
                  width="177"
              />
            </template>
            <template v-else>
              <nuxt-img
                  loading="lazy"
                  format="webp"
                  class="mx-auto cursor-pointer"
                  :src="siteURL + '/storage/images/gallery/' + album_path + '/thumbnail_cache/' +src.hash"
                  :alt="src.hash"
                  width="177"
              />
            </template>
          </div>
        </div>
        <div>
          <template v-if="modalPhoto === true && visibleRef">
              <div class="w-full h-40 bg-black photo-modal fixed top-0 left-0 z-[60]">
                <div class="justify-center items-center flex relative max-w-[80%] md:max-w-[800px] mx-auto flex-wrap pt-2 md:pt-4">
                  <div class="flex space-x-2 pr-2 sm:pr-0">
                    <div class="flex">
                      <h1 class="text-tiny md:text-3xl text-white mr-2 text-center">
                        <span>{{album.name}} - </span>
                        <span class="text-white text-red-500 mr-2 text-center">  {{images[indexRef].name}}</span>
                        <span class="text-white min-w-[50px] text-center">
                          | {{indexRef + 1}} / {{images.length}}
                        </span>
                      </h1>
                    </div>
                    <NuxtLink to="/checkout" :class="cartAnimation" class="text-white inline-block mx-3 md:ml-5 flex cart pt-[5px] ">
                      <svg class="z-20" xmlns="http://www.w3.org/2000/svg" width="24" height="24" x="0" y="0" viewBox="0 0 576 512" fill="white">
                        <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/>
                      </svg>
                      <div class="ml-1 z-20">
                        {{countCart}}
                      </div>
                    </NuxtLink>
                  </div>
                  <button @click="visibleRef = false" class="text-white fixed grid right-0 mr-3 sm:mt-2 top-0 sm:top-1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"  width="20" height="36" x="0" y="0" class="fill-white">
                      <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                    </svg>
                  </button>
                </div>

                <div class="justify-center mt-4 flex">
                  <div class="mr-2" v-on:click="favoritePhoto()">
                    <div class="justify-center flex cursor-pointer">
                      <img :class="favorite? 'flex':'hidden'"  src="/icons/heart.png" width="32" h="32"/>
                      <svg :class="favorite? 'hidden':'flex fill-white'" height="32" width="32" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 471.701 471.701" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M433.601,67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7,13.6-92.4,38.3l-12.9,12.9l-13.1-13.1 c-24.7-24.7-57.6-38.4-92.5-38.4c-34.8,0-67.6,13.6-92.2,38.2c-24.7,24.7-38.3,57.5-38.2,92.4c0,34.9,13.7,67.6,38.4,92.3 l187.8,187.8c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-3.9l188.2-187.5c24.7-24.7,38.3-57.5,38.3-92.4 C471.801,124.501,458.301,91.701,433.601,67.001z M414.401,232.701l-178.7,178l-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3 s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4 c19.6-19.6,45.7-30.4,73.3-30.4c27.6,0,53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3 C444.801,187.101,434.001,213.101,414.401,232.701z"></path> </g> </g></svg>
                      <p class=" ml-2 mr-5" :class="favorite? 'text-red-500':'text-white'">Favorite</p>
                    </div>
                  </div>
                  <div>
                      <div class="justify-center flex cursor-pointer" v-on:click="shareOn('facebook')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" x="0" y="0" viewBox="0 0 155.139 155.139" class="fill-white hover:bg-black bg-blue-700 p-2 rounded-full">
                          <g>
                             <g xmlns="http://www.w3.org/2000/svg">
                                <path id="f_1_" style="" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"  data-original="#010002" />
                             </g>
                          </g>
                        </svg>
                        <p class="text-blue-500 ml-2 mr-5">Share</p>
                      </div>
                  </div>
                  <button v-if="album.order_availability" class="justify-center flex"  @click="modalShop = !modalShop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" x="0" y="0" viewBox="0 0 576 512" class="fill-white hover:bg-black bg-red-700 p-2 rounded-full">
                      <g>
                         <g xmlns="http://www.w3.org/2000/svg" >
                           <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/>
                         </g>
                      </g>
                   </svg>
                   <p class="text-red-500 ml-2 mr-5">Buy Photo</p>
                  </button>
               </div>
              </div>
          </template>
          <template v-if="modalPhoto && modalShop && visibleRef && album.order_availability">
            <div class="bg-black fixed grid z-[60] shop-modal left-0 right-0 mx-auto translatey">
              <button @click="modalShop = false" class="text-white fixed grid right-0 mr-3 mt-3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" width="16" height="32" x="0" y="0" class="fill-white">
                  <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                </svg>
              </button>
              <div class="flex">
                <p class="text-4xl text-white mr-5">
                  SIZE
                </p>
                <p class="text-4xl text-white right">
                  PRICE
                </p>
              </div>
              <div>
                <p class="text-4xl text-white">
                  Print
                </p>
                <template v-for="option in photo_options">
                  <div v-if="option.product_type === 2">
<!--                    <Transition name="slide" class="relative">-->
                      <div class=" flex justify-between text-white mb-2 relative">
                        <Transition name="slide">
                          <div v-if="option.show" class="absolute bottom-0 right-0 w-full bg-darkRed">
                            <p></p>
                          </div>
                        </Transition>
<!--                        <div v-if="!show" class="absolute bottom-0 right-0 w-full bg-darkRed">-->
<!--                          <p class="text-white">Absolute child</p>-->
<!--                        </div>-->
                        <div class="flex items-center	">
                          <p class="mr-3 relative">{{option.title}}
                            <span class="cart-item"></span>
                          </p>
                          <button class="justify-center flex" @click="cartQuantity(option.id,'-')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" x="0" y="0" class="bg-white rounded-full">
                              <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>
                            </svg>
                          </button>
                          <p class="text-red-500 mr-2 ml-2">{{option.quantity}}</p>
                          <button class="justify-center flex" @click="cartQuantity(option.id,'+')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" x="0" y="0" class="fill-black bg-white rounded-full">
                              <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>
                            </svg>
                          </button>
                        </div>
                        <div class="flex items-center" >
                          <span>${{option.price}}</span>
                        <admin-jb-button
                            class="ml-3"
                            small
                            color="danger"
                            label="Select"
                            @click="addToCart(option.id)"
                        />
                        </div>
                      </div>
<!--                    </Transition>-->
                  </div>
                </template>
              </div>
              <div>
                <p class="text-4xl text-white mr-8">
                  Digital
                </p>
                <template v-for="option in photo_options">
                  <div class="flex text-white" v-if="option.product_type === 1">
                    <div class="flex w-full justify-between text-white mb-2 relative items-center">
                      <Transition name="slide">
                        <div v-if="option.show" class="absolute bottom-0 right-0 w-full bg-darkRed">
                          <p></p>
                        </div>
                      </Transition>
                      <p class="mb-3">{{option.title}}</p>
                      <div class="flex">
                        <span>${{option.price}}</span>
                        <admin-jb-button
                            class="ml-3"
                            small
                            color="danger"
                            :class="addToCartAnimation"
                            label="Select"
                            @click="addToCart(option.id)"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div>
          <vue-easy-lightbox :visible="visibleRef" :imgs="imgs" :index="indexRef" :maxZoom="0" :swipeTolerance="20" :zoomScale="0" loop :moveDisabled="true"  @click="modalPhoto = !modalPhoto" @hide="onHide" @on-next="onNext()" @on-prev="onPrev()">
            <template v-slot:close-btn="{ close }">
              <button @click="close()" class="text-white fixed grid right-0 mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"  width="16" height="32" x="0" y="0" class="fill-white">
                  <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                </svg>
              </button>
            </template>
            <template v-slot:toolbar="{ toolbarMethods }">
            </template>
          </vue-easy-lightbox>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner/>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import { useMainStore } from "@/stores/main";
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js'
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css'
import {http} from "~/utils/http";
import {useSiteURL,useSiteTitle,useSiteWeb} from "~/composables/state";
import {navigateTo, useHead, useRouter} from "nuxt/app";
import {useRoute} from "vue-router";
import {Galery} from "~/composables/nhTypes";

const siteURL = useSiteURL();
const siteWeb = useSiteWeb();
const router = useRouter()
const route = useRoute();
const mainStore = useMainStore();
const album_path = route.params.slug;
const visibleRef = ref(false)
const indexRef = ref(0)
const images = ref([]);
const album = ref(new Galery());
const photo_options = ref([]);
let modalShop = ref(false);
const imgs = ref([]);
const modalPhoto = ref(true);
const ready = ref(false);
const cartAnimation = ref('');
const addToCartAnimation = ref('');
const show = ref('false')
const siteTitle = useSiteTitle();
const image_thumbnail = ref(route.query.image_thumbnail ? route.query.image_thumbnail : '');
const index_thumbnail = ref(-1);
const og_image = ref('');
const favorite_photos = ref([]);
const favorite = computed(()=> favorite_photos.value.includes(images.value[indexRef.value].id));

useHead({
  title: computed(() => album.value.meta_title + ' - ' + siteTitle.value) ,
  meta: [
    {name: 'description', content:computed(() => album.value.meta_description)},
    {name: 'keywords', content:computed(() => album.value.meta_keywords)},
    { property: 'og:title', content: computed(() => album.value.meta_title + ' - ' + siteTitle.value) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() => album.value.meta_description) },
    { property: 'og:url', content:computed(() =>route.fullPath) },
    { property: 'og:image', content: computed(() => og_image.value)},
  ],
})

const cartProducts = computed(() => mainStore.cartProducts)
const countCart = computed(() => {
  if( cartProducts.value.length > 0 ){
    let count = 0;
    cartProducts.value.forEach((item)=>{
      count += item.quantity
    })
    return count;
  }
  else return 0;
})

const favoritePhoto = async () => {
  if(images.value[indexRef.value].id > 0){

    try {
      await http
          .post("/api/gallery/update-favorite", {
            image_id: images.value[indexRef.value].id,
            album_id: album.value.id
          });
    } catch (e) {
      if (e.response?.status === 401) {
        navigateTo('/login');
      }
    }

    if (favorite.value) {
      let i = favorite_photos.value.indexOf(images.value[indexRef.value].id);
      if (i >= 0) {
        favorite_photos.value.splice(i, 1);
      }
    } else {
      favorite_photos.value.push(images.value[indexRef.value].id);
    }
  }

}

const shareOn = (type) => {
  const url = siteWeb.value + '/photo-gallery/photos/'+album_path+'?image_thumbnail=' + images.value[indexRef.value].hash;
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-500,top=-500`;
  if(type === 'facebook'){
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank',params)
  }
  if(type === 'twitter') {
    window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', params)
  }
}

const cartQuantity = (id, type = null) => {
  let options_index = photo_options.value.map((item) => item.id).indexOf(id);

  if (type === '+') {
    photo_options.value[options_index].quantity++;
  } else if (type === '-') {
    if (photo_options.value[options_index].quantity > 1) {
      photo_options.value[options_index].quantity--;
    }
  }
}

const addToCart = (option_id) => {
  let options_index = photo_options.value.map((item) => item.id).indexOf(option_id);

  let payload = {
    cartId: images.value[indexRef.value].id+'-'+photo_options.value[options_index].id,
    product_id: images.value[indexRef.value].id,
    name: album.value.name + ' - ' + images.value[indexRef.value].name,
    price: photo_options.value[options_index].price,
    quantity: photo_options.value[options_index].quantity,
    option: photo_options.value[options_index].id,
    option_name: photo_options.value[options_index].title,
    category: photo_options.value[options_index].type_id,
    category_option: photo_options.value[options_index].item_type,
    product_type: photo_options.value[options_index].product_type,
    shipping_tax_ca: photo_options.value[options_index].shipping_tax_ca,
    shipping_tax_us: photo_options.value[options_index].shipping_tax_us,
    shipping_tax_za: photo_options.value[options_index].shipping_tax_za,
  }

  show.value= '';
  photo_options.value[options_index].show = !photo_options.value[options_index].show;
  setTimeout(()=>{
    photo_options.value[options_index].show = !photo_options.value[options_index].show;
  },100)

  mainStore.addProduct(payload);
}

const showImg = (index,hash) => {
  photo_options.value.forEach((item)=>{
    item.quantity = 1;
  })
  router.push({
    path: '/photo-gallery/photos/'+album_path,
    query: { image_thumbnail: hash },
  })
  indexRef.value = index;
  visibleRef.value = true;
}

const onNext =  () => {
  photo_options.value.forEach((item)=>{
    item.quantity = 1;
  })
  modalPhoto.value = !modalPhoto.value;
  indexRef.value++;
  if (indexRef.value === images.value.length) {
    indexRef.value = 0;
  }
  router.push({
    path: '/photo-gallery/photos/'+album_path,
    query: { image_thumbnail: images.value[indexRef.value].hash },
  })
}

const onPrev =  () => {
  photo_options.value.forEach((item)=>{
    item.quantity = 1;
  })
  modalPhoto.value = !modalPhoto.value;

  if (indexRef.value === 0) {
    indexRef.value = images.value.length;
  }
  indexRef.value--;
  router.push({
    path: '/photo-gallery/photos/'+album_path,
    query: { image_thumbnail: images.value[indexRef.value].hash },
  })
}

const onHide = () => {
  visibleRef.value = false
  router.push({
    path: '/photo-gallery/photos/'+album_path,
  })
}

const getAlbum = async () => {
  try {
    await http
        .get("/api/gallery/" + album_path)
        .then((response) => {
          album.value = response.data.album;
          album.value.order_availability = !!album.value.order_availability
          images.value = response.data.images;
          favorite_photos.value = response.data.favorite;
          // og_image.value = siteURL.value + '/storage/images/gallery/' + album_path + '/' + album.value.cover_photo;
          images.value.forEach(img => {
            imgs.value.push({
              src: siteURL.value +
                  '/storage/images/gallery/' +
                  album_path +
                  '/cache/' +
                  img.hash
            })
          })
          if(imgs.value.length > 0){
            og_image.value = imgs.value[0].src;
          }

          if(album.value.cover_photo){
            let i= images.value.map((item)=>item.name).indexOf(album.value.cover_photo);
              if(i>=0){
                og_image.value = siteURL.value + '/storage/images/gallery/' + album_path + '/cache/' + images.value[i].hash;
              }
          }

          ready.value = true;
        });
  } catch (e) {
    console.log(e);
  }
}

const getPhotoOffers = async () => {
  try {
    await http
        .get("/api/offers", {
          params: {
            id: '',
            type: 'photos'
          }
        })
        .then((response) => {
          photo_options.value = response.data.offers;
          photo_options.value.forEach((item)=>{
            item.quantity = 1;
            item.show = false;
          })
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
}

await Promise.all([getAlbum(), getPhotoOffers()]);

onMounted(()=>{
  if(image_thumbnail.value){
    let index = images.value.map((item)=>item.hash).indexOf(image_thumbnail.value);
    if(index >= 0){
      og_image.value = siteURL.value + '/storage/images/gallery/' + album_path + '/cache/' + image_thumbnail.value;
      index_thumbnail.value = index;
      showImg(index_thumbnail.value,image_thumbnail.value);
    }
  }
})
</script>
<style>

.translatey{
  top: 50%;
  transform: translateY(-50%);
  height: 50%;
}

@media (max-width:765.89px) {
  .shop-modal{
    padding: 20px;
    margin: 10px;
    height: 60vh;
  }
}
@media (min-width: 767px) {
  .shop-modal{
    padding: 30px 100px 30px 100px;
    max-width: 80%;
    width: 800px;
    height: 450px;
  }
}

.shop-modal{

  opacity: 80%;

}

.right{
  position: absolute;
  right: 0;
  width: auto;
  padding: 0 100px 0 0;
}

.photo-modal{
  opacity: 90%;
}

.vel-modal{
  z-index: 55!important;
  background-color: rgba(0, 0, 0, 0.9);
}

.vel-img{
  height: 100%;
  max-height: 95vh;
  cursor: pointer;
}


.slide-enter-active {
  transition: all 0.3s ease-out;
}

.slide-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-leave-to {
  transform: translatey(-70vh);
  opacity: 0;
  width: 20px;
  height: 20px;
  right: 20%;
}


</style>
